import { Progress } from 'antd'
import BigNumber from 'bignumber.js'
import Numeral from 'numeral'
import { useMemo } from 'react'
import { Link } from 'react-router-dom'

import Arrow from '@/assets/Arrow.png'
import WAN from '@/assets/WAN.png'
import { useLocalStorage } from '@/context/localstorage-context'
import { cutString } from '@/utils'

import {
  ArrowStyle,
  BottomArea,
  Card,
  CardContentCon,
  CardHeader,
  CardPart1,
  CardPart2,
  Container,
  Data,
  FeeRate,
  HeartPercent,
  Icon,
  IconContainer,
  MyCard,
  Percent,
  StakeData1,
  StakeData2,
  StoremanName,
  TextIcon,
} from './BridgeCard.module'

export const CardContent = ({ storeman }: { storeman: any }) => {
  const quota = useMemo(() => {
    if (storeman.quota) {
      const quotaValue = Numeral(storeman.quota).value() || 0
      const tmp = new BigNumber(quotaValue).gt('0') ? quotaValue : '0'
      return Numeral(tmp).format('0,0')
    } else {
      return storeman.quota
    }
  }, [storeman.quota])

  return (
    <CardContentCon>
      <CardPart1>
        <span style={{ fontSize: '12px', color: '#BFBFBF' }}>STAKE</span>
        <StakeData1 className="text-light-0 dark:text-white">
          {storeman.totalDeposit || '--/--'}
        </StakeData1>
      </CardPart1>
      <CardPart2>
        <span
          className="text-light-111 dark:text-light-222"
          style={{ fontSize: '18px' }}
        >
          {quota || '--/--'}
        </span>
        <StakeData2>QUOTA</StakeData2>
      </CardPart2>
    </CardContentCon>
  )
}

export default function CardPart({ storeman }: { storeman: any }) {
  const { theme } = useLocalStorage()
  const isdark = useMemo(() => theme === 'dark', [theme])

  const quota = useMemo(() => {
    const quotaValue = Numeral(storeman.quota).value() || 0
    return new BigNumber(quotaValue).gt('0') ? quotaValue : '0'
  }, [storeman.quota])

  const percent = useMemo(() => {
    const selfDeposit = Numeral(storeman.selfDeposit).value() || 1
    const per = new BigNumber(quota)
      .dividedBy(selfDeposit * 10)
      .multipliedBy(100)
      .toString(10)
    return Number(Number(per).toFixed(0))
  }, [quota, storeman.selfDeposit])

  return (
    <Container isdark={isdark}>
      <Link to={`/storemandetail/${storeman.wkAddr}`}>
        <Card className="card bg-white dark:bg-dark-222">
          <CardHeader>
            <div style={{ textAlign: 'left' }}>
              <IconContainer>
                <Icon src={storeman.imgdata} alt={storeman.name} />
              </IconContainer>
              <StoremanName className="text-light-0 dark:text-white">
                {storeman.name.startsWith('0x')
                  ? cutString(storeman.name, 8)
                  : storeman.name}
              </StoremanName>
            </div>
            <ArrowStyle className="arrowStyle" src={Arrow} alt="arrow" />
          </CardHeader>
          <Progress
            width={160}
            type="circle"
            trailColor={isdark ? '#135C8F' : '#F2F2F2'}
            strokeWidth={5}
            strokeColor={isdark ? '#112A3B' : '#D7DEE3'}
            percent={percent}
            format={() => <CardContent storeman={storeman} />}
          />
          <div style={{ height: '40px' }}>
            <BottomArea>
              <HeartPercent>
                <Percent>{storeman.activity}</Percent>
                <TextIcon>Activity</TextIcon>
              </HeartPercent>
              <FeeRate>
                <Percent style={{ color: '#2FBDF4' }}>
                  {storeman.delegateFee / 100 + '%'}
                </Percent>
                <TextIcon>Fee Rate</TextIcon>
              </FeeRate>
            </BottomArea>
          </div>
        </Card>
        <MyCard className="mycard bg-light-666 dark:bg-dark-555">
          <Data>
            <span>My Delegations</span>
            <span className="text-light-0 dark:text-white">
              {Numeral(storeman.myDeposit)
                .format('0,0.00')
                .replace(/\.?0+$/, '')}
              &nbsp;
              <img
                style={{ position: 'relative', top: '-1px' }}
                src={WAN}
                alt="WAN"
              />
            </span>
          </Data>
          <Data>
            <span>My Rewards</span>
            <span className="text-dark-111">
              {Numeral(storeman.myIncentive)
                .format('0,0.0000')
                .replace(/\.?0+$/, '')}
              &nbsp;
              <img
                style={{ position: 'relative', top: '-1px' }}
                src={WAN}
                alt="WAN"
              />
            </span>
          </Data>
        </MyCard>
      </Link>
    </Container>
  )
}
